function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
import { PassportUserManagementServiceClientConfigFactory } from "@amzn/coral-config_passport-user-management-service";
import { PassportUserManagementService, passportUserManagementServiceHttpBindingInterceptor } from "@amzn/coral_com-amazon-passportusermanagementservice";
import { CoralClientFactory, CoralFetchHandler, InterceptingHandler } from "@amzn/ihm-js-coral-client";
import envHelper from "../config/env";
import AcceptInvitation from "../models/AcceptInvitationRequest";
import CreateInvitationRequest from "../models/CreateInvitationRequest";
import GetDeactivatedUsersResponse from "../models/GetDeactivatedUsersResponse";
import GetInvitedUsersForLogisticsPartyResponse from "../models/GetInvitedUsersForLogisticsPartyResponse";
import GetRequestedUserProfileInfoResponse from "../models/GetRequestedUserProfileInfoResponse";
import GetUserProfileInfoResponse from "../models/GetUserProfileInfoResponse";
import GetUsersForLogisticsPartyResponse from "../models/GetUsersForLogisticsPartyResponse";
import UpdateUserProfileInfoRequest from "../models/UpdateUserProfileInfoRequest";
import UpdateUserProfileInfoResponse from "../models/UpdateUserProfileInfoResponse";
import isSiteExternal from "../utils/isSiteExternal";
import PassportRequestOptionsInterceptor from "./PassportRequestOptionsInterceptor";
import RequestOptionsInterceptor from "./RequestOptionsInterceptor";
var clientFactory = new CoralClientFactory([
    PassportUserManagementServiceClientConfigFactory
], envHelper.getEnv(), new InterceptingHandler(new CoralFetchHandler(), [
    passportUserManagementServiceHttpBindingInterceptor,
    isSiteExternal() ? new RequestOptionsInterceptor() : new PassportRequestOptionsInterceptor(), 
]));
/**
 * Custom web server to override serialization/deserialization
 */ var CustomWebServer = /*#__PURE__*/ function(PassportUserManagementService1) {
    "use strict";
    _inherits(CustomWebServer, PassportUserManagementService1);
    var _super = _createSuper(CustomWebServer);
    function CustomWebServer(config, handler) {
        _classCallCheck(this, CustomWebServer);
        var _this;
        _this = _super.call(this, config, handler);
        _this.handler.handlerChain.interceptor.operations.GetUserProfileInfo.deserializationFn = GetUserProfileInfoResponse.fromJson;
        _this.handler.handlerChain.interceptor.operations.UpdateUserProfileInfo.serializationFn = UpdateUserProfileInfoRequest.toJson;
        // to handle inheritacne in coral models
        _this.handler.handlerChain.interceptor.operations.UpdateUserProfileInfo.deserializationFn = UpdateUserProfileInfoResponse.fromJson;
        _this.handler.handlerChain.interceptor.operations.AcceptInvitation.serializationFn = AcceptInvitation.toJson;
        _this.handler.handlerChain.interceptor.operations.GetUsersForLogisticsParty.deserializationFn = GetUsersForLogisticsPartyResponse.fromJson;
        _this.handler.handlerChain.interceptor.operations.GetInvitedUsersForLogisticsParty.deserializationFn = GetInvitedUsersForLogisticsPartyResponse.fromJson;
        _this.handler.handlerChain.interceptor.operations.CreateInvitation.serializationFn = CreateInvitationRequest.toJson;
        _this.handler.handlerChain.interceptor.operations.GetDeactivatedUsers.deserializationFn = GetDeactivatedUsersResponse.fromJson;
        _this.handler.handlerChain.interceptor.operations.GetRequestedUserProfileInfo.deserializationFn = GetRequestedUserProfileInfoResponse.fromJson;
        return _this;
    }
    return CustomWebServer;
}(PassportUserManagementService);
var passportUserManagementServiceClient = clientFactory.get(CustomWebServer);
export default passportUserManagementServiceClient;

//# sourceMappingURL=PassportUserManagementServiceClient.js.map